import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
import editRenew from './editRenew';
export default {
  getList,
  add,
  del,
  edit,
  editRenew
};


// WEBPACK FOOTER //
// ./src/api/contractmanager/index.ts